// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__MNcaX","errors":"Errors_errors__3MoV2"};